export const parent = "p1rha9ax";
export const featureStyle = "f1xlrjjs";
export const featureText = "f1l0p7vq";
export const featureIcon = "fx7t9cz";

require("./styles.linaria.module.css!=!../../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");